const getPermissionCount = (permissions) => {
    let count = 0
    
    for(const category in permissions){
        for(const permission in permissions[category]){
            if(permissions[category][permission] === true) count++;
        }
    }
    
    return count;
}

export {
    getPermissionCount
}